import React from 'react';
import Card from '../Card';
import CardHeader from '../CardHeader';
import PointOfSales from '../PointOfSales';
import isEmpty from 'lodash/isEmpty';

import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';

const NoLostPoint = styled.div`
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  text-align: left;
  font-size: 12px;
`;

const SubtitleCard = styled.div`
  width: auto;
  margin-bottom: 32px;
  p {
    opacity: 0.5;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
    font-weight: normal;
    font-style: italic;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${(props) => props.theme.colors['dark']};
  }
`;

const ContentPoints = styled.div`
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 30px;
  display: grid;
  @media screen and (max-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
const LostPointsOfSale = ({ data }) => (
  <Card>
    <CardHeader
      title={I18n.t('restaurants&caves.pos.lostPov.title')}
      fontSize="20px"
      iconRight="right"
    />
    <SubtitleCard>
      <p>{I18n.t('restaurants&caves.pos.lostPov.explainText')}</p>
    </SubtitleCard>
    {isEmpty(data) ? (
      <NoLostPoint>
        {I18n.t('restaurants&caves.pos.lostPov.explainTextNone')}
      </NoLostPoint>
    ) : (
      <ContentPoints>
        {data.map((point, index) => (
          <PointOfSales key={`lostPos-${index}`} {...point} />
        ))}
      </ContentPoints>
    )}
  </Card>
);
export default LostPointsOfSale;
